import { useTranslations } from 'next-intl';

import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';

import { Icon } from '../ui/icon';

type Props = {
  title?: string;
  description?: string;
};

function AlertError(props: Props) {
  const { description, title } = props;
  const translate = useTranslations();

  return (
    <Alert variant="error">
      <div className="flex items-start gap-2">
        <Icon icon="material-symbols:error" />

        <div className="mt-1 flex flex-col items-center gap-2">
          <AlertTitle>{title ?? translate('globalErrorTitle')}</AlertTitle>

          {description && <AlertDescription>{description}</AlertDescription>}
        </div>
      </div>
    </Alert>
  );
}

export default AlertError;
